// extracted by mini-css-extract-plugin
var _1 = "webpack-components-shared-ReviewEligibilityCriteria-components-CriteriaDescription-CriteriaDescription-module__criteriaItemText";
var _2 = "webpack-components-shared-ReviewEligibilityCriteria-components-CriteriaDescription-CriteriaDescription-module__na";
export { _1 as "criteriaItemText", _2 as "na" }
